'use client'

import { Burger } from "@mantine/core";
import { FaPlus } from "react-icons/fa";
import PageSpecificTabs from "../drawers/page-specific-tabs";
import { TabItem } from "../wrappers/navWrapper";

export default function MainHeader({ pathname, openActions, opened, width, open, currName, specificTab, editList, tabs, specificPageBool, specificObjectName, userVerified }: Readonly<{ pathname: string; openActions: () => void; opened: boolean; width: number; open: () => void; currName: string; specificTab: number; editList: boolean; tabs: TabItem[]; specificPageBool: boolean; specificObjectName: string; userVerified: boolean; }>) {

    return (
        pathname === '/' ? (

            <header className="flex flex-row justify-between items-center w-full shadow-md p-4 bg-emerald-600 h-content">
                <h1 className="text-2xl font-semibold text-white w-full text-center p-2">Welcome to Plantr!</h1>
            </header>

        ) : (

            <header className={`flex flex-row ${specificPageBool ? 'justify-between items-center' : 'justify-start items-center'} px-6 sm:px-8 py-3 w-full shadow-md bg-emerald-600 h-content`}>

                <div className={`flex flex-row justify-start items-center space-x-3 md:space-x-5 w-full h-content`}>

                    <div className="rounded-md hover:bg-emerald-700 transition-all duration-200 ease-in-out">
                        <Burger variant="unstyled" opened={opened} size="md" color="white" onClick={open} styles={{ root: { backgroundColor: 'transparent', '&:hover': { backgroundColor: '#047857' } } }} />
                    </div>

                    {userVerified && <div className="min-h-[24px] min-w-1 border-l-2 border-white" />}

                    {userVerified && <button onClick={openActions} className="flex flex-row justify-evenly items-center w-fit p-2 rounded-md hover:bg-emerald-700 transition-all duration-200 ease-in-out">
                        <FaPlus size={16} color="white" />
                        {width >= 640 && <p className="pl-2 text-white text-font-medium cursor-pointer">Add New</p>}
                    </button>}

                </div>


                {specificPageBool && <PageSpecificTabs currTab={specificTab} editList={editList} tabs={tabs} specificObjectName={specificObjectName} />}
                {!specificPageBool && (
                    <h1 className="text-white font-semibold text-lg sm:text-xl md:text-2xl truncate max-w-1/2 w-full text-end pr-2 sm:pr-4">
                        {currName}
                    </h1>
                )}
                {/* {type !== '' ? (
                    
                ) : (
                    <Link href={'/'} type="button" onClick={() => setGlobalLoading(true)} className="text-white p-2 rounded-md hover:bg-emerald-700 transition-all duration-200 ease-in-out cursor-pointer font-medium">
                        {width < 640 ? <FaHome size={18} title="Plantr Co. Home" /> : 'Plantr Co.'}
                    </Link>
                )} */}

            </header>

        )
    )
}